import styled, { css } from 'styled-components'

import { BorderLoader } from '@/components/ui/loaders/border-loader'

export const ProductsContainer = styled.div<{ $hasProductsInCart: boolean }>(
  ({ theme, $hasProductsInCart }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']} ${theme.space['16']}
      ${$hasProductsInCart ? theme.space['80'] : theme.space['16']};
    overflow: hidden auto;
    height: 100%;
  `,
)

export const ProductsWrapper = styled.div<{ $hasProductsToShow: boolean }>(
  ({ theme, $hasProductsToShow }) => css`
    display: ${$hasProductsToShow ? 'grid' : 'none'};
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: ${theme.space['16']};
    width: 100%;
    height: fit-content;
  `,
)

export const Loader = styled(BorderLoader)<{ $hasContent: boolean }>(
  ({ theme, $hasContent }) => css`
    flex-shrink: 0;
    margin: ${$hasContent ? theme.space['100'] : 'auto'} auto;
  `,
)
